// Entrega de pedidos (espejo de functions/entregaPedido.js para formularios y vistas).
// El envío a provincia se hace por agencia; el flete se paga en destino o se coordina.

export const DEPARTAMENTOS = Object.freeze(['Amazonas', 'Áncash', 'Apurímac', 'Arequipa', 'Ayacucho', 'Cajamarca', 'Callao', 'Cusco',
  'Huancavelica', 'Huánuco', 'Ica', 'Junín', 'La Libertad', 'Lambayeque', 'Lima', 'Loreto', 'Madre de Dios', 'Moquegua',
  'Pasco', 'Piura', 'Puno', 'San Martín', 'Tacna', 'Tumbes', 'Ucayali']);
export const MAX_AGENCIAS = 8;
export const AGENCIAS_SUGERIDAS = Object.freeze(['Shalom', 'Olva Courier', 'Marvisur', 'Cruz del Sur Cargo']);

/** Agencias escritas por el gimnasio («Shalom, Olva»): sin repetidos ni espacios dobles. */
export const listaAgencias = (valor) => {
  const entrada = Array.isArray(valor) ? valor : String(valor || '').split(',');
  const vistas = new Set(), salida = [];
  entrada.forEach(v => {
    const nombre = String(v || '').trim().replace(/\s+/g, ' ').slice(0, 40);
    if (nombre && !vistas.has(nombre.toLowerCase())) { vistas.add(nombre.toLowerCase()); salida.push(nombre); }
  });
  return salida;
};

/** Texto corto del destino: «Arequipa, Arequipa · Shalom». */
export const destinoEnvio = (entrega) => {
  if (entrega?.tipo !== 'provincia') return '';
  const lugar = [entrega.distrito, entrega.provincia, entrega.departamento].filter(Boolean).join(', ');
  return `${lugar}${entrega.agencia ? ` · ${entrega.agencia}` : ''}`;
};

export const etiquetaEntrega = (tipo) => ({ retiro: 'Retiro en tienda', delivery: 'Delivery', provincia: 'Envío a provincia' }[tipo] || 'Por coordinar');

// ── Rótulo de envío a provincia ─────────────────────────────────────────────
// Datos para la agencia, precargados con lo que dejó el cliente. El destinatario
// se guarda aparte del comprador (su DNI y celular sirven para «Mis pedidos»).
export const envioRotuloInicial = (orden = {}) => {
  const entrega = orden.entrega || {}, cliente = orden.cliente || {}, destinatario = entrega.destinatario || {};
  return {
    destinatario: { nombre: destinatario.nombre || cliente.nombre || '', dni: destinatario.dni || cliente.dni || '',
      telefono: destinatario.telefono || cliente.telefono || '' },
    departamento: entrega.departamento || '', provincia: entrega.provincia || '', distrito: entrega.distrito || '',
    agencia: entrega.agencia || '', direccion: entrega.direccion || '',
  };
};

/** Lista de lo que falta para imprimir (mismas reglas que el backend); vacía si está completo. */
export const faltantesEnvioRotulo = (envio = {}) => {
  const d = envio.destinatario || {};
  return [
    !String(d.nombre || '').trim() && 'nombre de quien recoge',
    !/^\d{8}$/.test(String(d.dni || '').trim()) && 'DNI de 8 dígitos',
    !/^9\d{8}$/.test(String(d.telefono || '').replace(/\D/g, '')) && 'celular de 9 dígitos',
    !DEPARTAMENTOS.includes(envio.departamento) && 'departamento',
    !String(envio.provincia || '').trim() && 'provincia',
    !String(envio.agencia || '').trim() && 'agencia',
    !String(envio.direccion || '').trim() && 'sede de la agencia',
  ].filter(Boolean);
};

const limpio = (valor) => String(valor ?? '').trim().replace(/\s+/g, ' ');
/** true si el admin cambió algo respecto de lo guardado (solo entonces se invoca al backend). */
export const envioRotuloCambio = (orden, envio) => {
  const guardado = orden?.entrega?.destinatario ? envioRotuloInicial(orden) : null;
  if (!guardado) return true; // nunca se guardó un destinatario: se registra al imprimir
  const plano = (e) => [e.destinatario.nombre, e.destinatario.dni, String(e.destinatario.telefono).replace(/\D/g, ''),
    e.departamento, e.provincia, e.distrito, e.agencia, e.direccion].map(limpio).join('|');
  return plano(guardado) !== plano(envio);
};
